export default __webpack_public_path__ + "static/media/bok.a5bc1d67.png";